module.exports = __webpack_public_path__ + "img/home2.95fd730d.png";